export const EMAIL_REGEX = '^[^@]+@[^@]+\\.[^@]+$'

export function completeEmployeeInvitations (authClient) {
  const idToken = authClient.tokens?.idToken
  if (!idToken) return

  fetch('/api/user/complete-employee-invitations/', {
    method: 'POST',
    keepalive: true,
    headers: {
      Authorization: `Bearer ${idToken}`
    }
  }).catch(() => {
    // best-effort completion callback; auth flow should not fail on callback issues
  })
}
